export const ALL_ASSETS_SINGLE_MOCK = [
  {
    id: 84,
    contract: {
      id: 3,
      network: 137,
      name: 'Reality NFT',
      address: '0x0F28954Ba506F2A350d3b27d26fad660E2Fee267',
      nft_version: '1.0',
      asset_contract_type: 'non-fungible',
      schema_name: 'ERC1155',
      visible: true,
      deployed_at: 36902864,
      collection: 3,
    },
    address: 'Malacca, MY',
    traits: [
      {
        id: 624575,
        type: '_id',
        value: '405',
        asset: 84,
      },
      {
        id: 624578,
        type: 'location_lat',
        value: '2.1975',
        asset: 84,
      },
      {
        id: 624581,
        type: 'location_lon',
        value: '102.24681',
        asset: 84,
      },
      {
        id: 624584,
        type: 'type',
        value: 'building',
        asset: 84,
      },
      {
        id: 624587,
        type: 'category',
        value: 'historic site',
        asset: 84,
      },
      {
        id: 624590,
        type: 'country_code',
        value: 'MY',
        asset: 84,
      },
      {
        id: 624593,
        type: 'street',
        value: '25, Jalan Tokong',
        asset: 84,
      },
      {
        id: 624596,
        type: 'settlement',
        value: 'Malacca',
        asset: 84,
      },
      {
        id: 624599,
        type: 'country_name',
        value: 'Malaysia',
        asset: 84,
      },
    ],
    owned_shares: 0,
    total_shares: 1150,
    current_lowest_price_per_share: 0,
    lowest_possible_price: {
      price: null,
      currency_amount: null,
      currency: null,
    },
    last_sale_price: {
      price: 2000000000000000000000,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    shares_currently_on_sale: null,
    last_day_income: {
      income: 59299631534041175425024,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    last_week_income: {
      income: 59421928436811765383168,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    name: 'Cheng Hoon Teng Temple',
    token_id: '405',
    description: 'Cheng Hoon Teng Temple',
    details: 2,
    marker_url: 'https://assets.r5y.io/lgo-live/icons/category_historic_site.png',
    image_original_url: 'https://assets.r5y.io/lgo-live/images/405.jpg',
    animation_url: 'https://assets.r5y.io/lgo-live/animations/405.mp4',
    asset_original_url: 'https://assets.r5y.io/lgo-live/images/405.jpg',
  },
];

export const ALL_ASSETS_MULTIPLE_MOCK = [
  {
    id: 582,
    contract: {
      id: 3,
      network: 137,
      name: 'Reality NFT',
      address: '0x0F28954Ba506F2A350d3b27d26fad660E2Fee267',
      nft_version: '1.0',
      asset_contract_type: 'non-fungible',
      schema_name: 'ERC1155',
      visible: true,
      deployed_at: 36902864,
      collection: 3,
    },
    address: 'Minsk, BY',
    traits: [
      {
        id: 620075,
        type: '_id',
        value: '1247',
        asset: 582,
      },
      {
        id: 620078,
        type: 'location_lat',
        value: '53.9024716',
        asset: 582,
      },
      {
        id: 620081,
        type: 'location_lon',
        value: '27.5618225',
        asset: 582,
      },
      {
        id: 620084,
        type: 'type',
        value: 'city',
        asset: 582,
      },
      {
        id: 620087,
        type: 'category',
        value: 'city',
        asset: 582,
      },
      {
        id: 620090,
        type: 'country_code',
        value: 'BY',
        asset: 582,
      },
      {
        id: 620093,
        type: 'settlement',
        value: 'Minsk',
        asset: 582,
      },
      {
        id: 620096,
        type: 'country_name',
        value: 'Belarus',
        asset: 582,
      },
    ],
    owned_shares: 0,
    total_shares: 1750,
    current_lowest_price_per_share: 0,
    lowest_possible_price: {
      price: '1099000000000000000000',
      currency_amount: null,
      currency: null,
    },
    last_sale_price: {
      price: 999000000000000000000,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    shares_currently_on_sale: 51,
    last_day_income: {
      income: 27807105135294119936,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    last_week_income: {
      income: 158827038982352961536,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    name: 'Minsk',
    token_id: '1247',
    description: 'Minsk',
    details: 2,
    marker_url: 'https://assets.r5y.io/lgo-live/icons/category_city.png',
    image_original_url: 'https://assets.r5y.io/lgo-live/images/1247.jpg',
    animation_url: 'https://assets.r5y.io/lgo-live/animations/1247.mp4',
    asset_original_url: 'https://assets.r5y.io/lgo-live/images/1247.jpg',
  },
  {
    id: 720,
    contract: {
      id: 3,
      network: 137,
      name: 'Reality NFT',
      address: '0x0F28954Ba506F2A350d3b27d26fad660E2Fee267',
      nft_version: '1.0',
      asset_contract_type: 'non-fungible',
      schema_name: 'ERC1155',
      visible: true,
      deployed_at: 36902864,
      collection: 3,
    },
    address: 'Washington, US',
    traits: [
      {
        id: 624602,
        type: '_id',
        value: '1103',
        asset: 720,
      },
      {
        id: 624605,
        type: 'location_lat',
        value: '38.889278',
        asset: 720,
      },
      {
        id: 624608,
        type: 'location_lon',
        value: '-77.050166',
        asset: 720,
      },
      {
        id: 624611,
        type: 'type',
        value: 'building',
        asset: 720,
      },
      {
        id: 624614,
        type: 'category',
        value: 'historic site',
        asset: 720,
      },
      {
        id: 624617,
        type: 'country_code',
        value: 'US',
        asset: 720,
      },
      {
        id: 624620,
        type: 'street',
        value: '2 Lincoln Memorial Circle NW',
        asset: 720,
      },
      {
        id: 624623,
        type: 'settlement',
        value: 'Washington',
        asset: 720,
      },
      {
        id: 624626,
        type: 'country_name',
        value: 'United States',
        asset: 720,
      },
    ],
    owned_shares: 0,
    total_shares: 3000,
    current_lowest_price_per_share: 0,
    lowest_possible_price: {
      price: null,
      currency_amount: null,
      currency: null,
    },
    last_sale_price: {
      price: 1999000000000000000000,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    shares_currently_on_sale: 50,
    last_day_income: {
      income: 60248727794117648384,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    last_week_income: {
      income: 318762506011764654080,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    name: 'Lincoln Memorial',
    token_id: '1103',
    description: 'Lincoln Memorial',
    details: 2,
    marker_url: 'https://assets.r5y.io/lgo-live/icons/category_historic_site.png',
    image_original_url: 'https://assets.r5y.io/lgo-live/images/1103.jpg',
    animation_url: 'https://assets.r5y.io/lgo-live/animations/1103.mp4',
    asset_original_url: 'https://assets.r5y.io/lgo-live/images/1103.jpg',
  },
  {
    id: 750,
    contract: {
      id: 3,
      network: 137,
      name: 'Reality NFT',
      address: '0x0F28954Ba506F2A350d3b27d26fad660E2Fee267',
      nft_version: '1.0',
      asset_contract_type: 'non-fungible',
      schema_name: 'ERC1155',
      visible: true,
      deployed_at: 36902864,
      collection: 3,
    },
    address: 'Dublin, IE',
    traits: [
      {
        id: 624551,
        type: '_id',
        value: '592',
        asset: 750,
      },
      {
        id: 624554,
        type: 'location_lat',
        value: '53.3493795',
        asset: 750,
      },
      {
        id: 624557,
        type: 'location_lon',
        value: '-6.2605593',
        asset: 750,
      },
      {
        id: 624560,
        type: 'type',
        value: 'city',
        asset: 750,
      },
      {
        id: 624563,
        type: 'category',
        value: 'city',
        asset: 750,
      },
      {
        id: 624566,
        type: 'country_code',
        value: 'IE',
        asset: 750,
      },
      {
        id: 624569,
        type: 'settlement',
        value: 'Dublin',
        asset: 750,
      },
      {
        id: 624572,
        type: 'country_name',
        value: 'Ireland',
        asset: 750,
      },
    ],
    owned_shares: 0,
    total_shares: 2250,
    current_lowest_price_per_share: 0,
    lowest_possible_price: {
      price: null,
      currency_amount: null,
      currency: null,
    },
    last_sale_price: {
      price: 1099000000000000000000,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    shares_currently_on_sale: 50,
    last_day_income: {
      income: 56509687347058819072,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    last_week_income: {
      income: 238367167664705863680,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    name: 'Dublin',
    token_id: '592',
    description: 'Dublin',
    details: 2,
    marker_url: 'https://assets.r5y.io/lgo-live/icons/category_city.png',
    image_original_url: 'https://assets.r5y.io/lgo-live/images/592.jpg',
    animation_url: 'https://assets.r5y.io/lgo-live/animations/592.mp4',
    asset_original_url: 'https://assets.r5y.io/lgo-live/images/592.jpg',
  },
  {
    id: 1050,
    contract: {
      id: 3,
      network: 137,
      name: 'Reality NFT',
      address: '0x0F28954Ba506F2A350d3b27d26fad660E2Fee267',
      nft_version: '1.0',
      asset_contract_type: 'non-fungible',
      schema_name: 'ERC1155',
      visible: true,
      deployed_at: 36902864,
      collection: 3,
    },
    address: 'MA',
    traits: [
      {
        id: 624404,
        type: '_id',
        value: '1285',
        asset: 1050,
      },
      {
        id: 624407,
        type: 'location_lat',
        value: '31.1728205',
        asset: 1050,
      },
      {
        id: 624410,
        type: 'location_lon',
        value: '-7.3362482',
        asset: 1050,
      },
      {
        id: 624413,
        type: 'type',
        value: 'country',
        asset: 1050,
      },
      {
        id: 624416,
        type: 'category',
        value: 'country',
        asset: 1050,
      },
      {
        id: 624419,
        type: 'country_code',
        value: 'MA',
        asset: 1050,
      },
      {
        id: 624422,
        type: 'country_name',
        value: 'Morocco',
        asset: 1050,
      },
    ],
    owned_shares: 0,
    total_shares: 2500,
    current_lowest_price_per_share: 0,
    lowest_possible_price: {
      price: null,
      currency_amount: null,
      currency: null,
    },
    last_sale_price: {
      price: 1945000000000000000000,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    shares_currently_on_sale: null,
    last_day_income: {
      income: 13789029126564707565568,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    last_week_income: {
      income: 13905360326764705873920,
      currency: {
        id: 6,
        network: 137,
        name: 'RMV',
        symbol: 'RMV',
        address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
        decimal: 18,
      },
    },
    name: 'Morocco',
    token_id: '1285',
    description: 'Morocco',
    details: 2,
    marker_url: 'https://assets.r5y.io/lgo-live/icons/category_country.png',
    image_original_url: 'https://assets.r5y.io/lgo-live/images/1285.jpg',
    animation_url: 'https://assets.r5y.io/lgo-live/animations/1285.mp4',
    asset_original_url: 'https://assets.r5y.io/lgo-live/images/1285.jpg',
  },
];

